import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InstallMobileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"install_mobile"}/>
}
